import { render } from "./ModalChooseMajor.vue?vue&type=template&id=026f59ca&ts=true"
import script from "./ModalChooseMajor.vue?vue&type=script&lang=ts"
export * from "./ModalChooseMajor.vue?vue&type=script&lang=ts"

import "./ModalChooseMajor.vue?vue&type=style&index=0&id=026f59ca&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__